import { appGetState } from 'legacy/lut/store'

import { getTokens } from 'core/classes/helpers/StorageHelper'
import { proxy } from 'core/classes/helpers/UrlHelper'
import { HttpHeaders, Rest } from 'core/classes/http'

import { recordAcknowledgmentCall } from './recordAcknowledgmentCall'

type RestoreAcknowledgmentParams = {
  partnerId: string
  fYear: number
  programType: string
  /** A distributor's acknowledgment is shared by every offering, so it is restored as a whole. */
  isDistributor?: boolean
  debugSource?: string | null
}

export const restoreAcknowledgment = ({
  partnerId,
  fYear,
  programType,
  isDistributor,
  debugSource,
}: RestoreAcknowledgmentParams) => {
  const url = proxy('/webservice/621/sp/v3/spJBPAcknowlegmentRestore/call')
  const [accessToken] = getTokens(appGetState().app.ownerId)
  const headers = new HttpHeaders()

  if (accessToken) {
    headers.add('Authorization', `Bearer ${accessToken}`)
  }

  const payload = {
    'p.PartnerId': partnerId,
    'p.FYear': fYear,
    'p.ProgramType': isDistributor ? null : programType,
  }

  return recordAcknowledgmentCall(
    {
      name: 'spJBPAcknowlegmentRestore',
      method: 'POST',
      url,
      body: payload,
      target: 'AcknowledgmentHistory · refetch',
      source: debugSource,
    },
    () => Rest.post({ url, payload, headers })
  )
}
